const faqItems = [
  {
    q: '每日大赛黑料的内容来源可靠吗？',
    a: '每日大赛黑料所有内容均来自网友投稿、公开报道整理及一线线人爆料，我们会对信息进行交叉核实后再发布。但因八卦信息特殊性，部分内容可能存在偏差，请理性吃瓜。每日大赛黑料致力于为吃瓜群众提供最及时的大赛吃瓜资讯，但不对内容的绝对真实性作担保。',
  },
  {
    q: '如何加入黑料吃瓜群获取第一手爆料？',
    a: '您可以通过本站上方的"加入黑料吃瓜群"入口扫码加入我们的社群。每日大赛黑料吃瓜群每天实时推送最新大赛内幕、每日吃瓜爆料和大赛八卦信息，群内还有资深吃瓜群众深度讨论。目前支持微信群和QQ群两种方式。',
  },
  {
    q: '本站的大赛吃瓜内容涵盖哪些类型的赛事？',
    a: '每日大赛黑料覆盖范围广泛，包括但不限于：选秀类大赛（如偶像选拔、达人竞技）、综艺真人秀比赛、电竞赛事、网红主播PK赛、才艺比拼等各类竞技赛事。只要有大瓜可吃，每日大赛黑料就不会缺席。',
  },
  {
    q: '如何在每日大赛黑料上投稿爆料？',
    a: '欢迎通过"联系我们"页面提交您的独家爆料。投稿一经采用，我们会保护投稿人隐私，并在每日大赛黑料首页显著位置展示。高质量的黑料吃瓜内容还会获得额外曝光推荐。请确保投递内容符合社区规范。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-8 md:mb-12 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            关于每日大赛黑料的那些事儿，这里都给你整明白了
          </p>
        </div>

        <div className="max-w-3xl mx-auto divide-y divide-background-200/70">
          {faqItems.map((item, i) => (
            <div key={i} className="py-5 md:py-6">
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center mt-0.5">
                  <span className="text-primary-600 text-xs font-bold">Q</span>
                </span>
                {item.q}
              </h3>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed pl-9">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}